



  import { Component, Vue } from 'vue-property-decorator';

@Component({
  name:"Administration"
})
export default class Administration extends Vue {}
